import React, { useEffect } from 'react'
import styles from './style.module.scss'
import { SectionWrapper } from '@Root/HOCs'
import { useHistory, useLocation } from 'react-router'
import { CreateQualification } from './Create'
import { fieldTooltipManagerActions, modalActions } from '@Root/store'
import { useDispatch } from 'react-redux'
import { qualificationActions } from '@Store/admin'
import { EditQualification } from './Edit'

const PARENT_URL = '/home/admin/data/qualifications'
export const QualificationPage = () => {
	const history = useHistory()
	const location = useLocation()
	const dispatch = useDispatch()
	const pathname = location.pathname
	const isNew = pathname.includes('new')

	useEffect(() => {
		dispatch(qualificationActions.getStaticOptions())
		dispatch(
			fieldTooltipManagerActions.getDescriptions({
				entity: 'admin',
				entity_type: 'qualifications',
			})
		)
	}, [dispatch])

	const onOpenDescriptionModal = (description, title) => {
		new Promise((resolve, reject) => {
			dispatch(modalActions.showModal('NotificationModal', { text: description, clickRejectButtonHandler: reject, clickResolveButtonHandler: resolve, title }))
		}).finally(() => dispatch(modalActions.hideModal()))
	}

	return (
		<SectionWrapper hasBackButton backButtonText='Qualifications' clickBackButtonHandler={() => history.push(PARENT_URL)}>
			<div className={styles.wrapper}>
				{isNew ? (
					<CreateQualification onOpenDescriptionModal={onOpenDescriptionModal} parentURL={PARENT_URL} />
				) : (
					<EditQualification onOpenDescriptionModal={onOpenDescriptionModal} />
				)}
			</div>
		</SectionWrapper>
	)
}
